var $cookieBanner = $('#cookieBanner');
!function () {
    var hint = $.cookie('shopCookieAnalyticsHint');

    if ($cookieBanner.length > 0 && !hint) {
        var close = $cookieBanner.find('.close');
        $cookieBanner.show();

        close.on('click', function () {
            $.cookie('shopCookieAnalyticsHint', 'accepted', {
                expires: 365
            });
            $cookieBanner.animate({
                'margin-top': -$cookieBanner.outerHeight()
            }, 300, function () {
                $cookieBanner.hide();
                $cookieBanner = undefined;
            });
            $('body').animate({
                'padding-top': 0
            }, 300)
                .removeClass('cookieHint');
        });
    }
}();